import { GET_PROMO_SLIDER } from "./actionTypes";
import { GET_PROMO_BANNER } from "./actionTypes";

const initialState = {
    promo_slides: [],
    promo_banners: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_PROMO_SLIDER:
            return { ...state, promo_slides: action.payload };
		case GET_PROMO_BANNER:
            return { ...state, promo_banners: action.payload };
        default:
            return state;
    }
}
